import { useRef } from 'react';
import {
   AlertDialog,
   AlertDialogOverlay,
   AlertDialogContent,
   AlertDialogHeader,
   AlertDialogBody,
   AlertDialogFooter,
   Button,
   HStack,
} from '@chakra-ui/react';
import { useLocalization } from '~/framework';

type BulkCompletionChangeConfirmationProps = {
   header: string;
   isOpen: boolean;
   onClose: () => void;
   onConfirm: () => void;
   confirmText?: string | null;
};

export function BulkCompletionChangeConfirmation({
   header,
   isOpen,
   onClose,
   onConfirm,
   confirmText = null,
}: BulkCompletionChangeConfirmationProps) {
   const { _js } = useLocalization();
   const cancelRef = useRef<HTMLButtonElement>(null);

   return (
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
         <AlertDialogOverlay>
            <AlertDialogContent>
               <AlertDialogHeader fontSize="xl" fontWeight="bold">
                  {header}
               </AlertDialogHeader>

               <AlertDialogBody fontSize="md">
                  {_js(
                     'This action will affect completions for all members of the team. Are you sure?'
                  )}
               </AlertDialogBody>

               <AlertDialogFooter>
                  <HStack spacing={3}>
                     <Button ref={cancelRef} onClick={onClose}>
                        {_js('Cancel')}
                     </Button>
                     <Button
                        variant="solid"
                        colorScheme="red"
                        onClick={() => {
                           onConfirm();
                           onClose();
                        }}
                     >
                        {confirmText ?? _js('Confirm')}
                     </Button>
                  </HStack>
               </AlertDialogFooter>
            </AlertDialogContent>
         </AlertDialogOverlay>
      </AlertDialog>
   );
}
